import React from "react";
import { ScanSearch, Sparkles, AlertTriangle } from "lucide-react";

export const INSIGHT_META = {
  detected: {
    Icon: ScanSearch,
    label: "Dato detectado",
    iconColor: "#475569",
    chipBg: "bg-[#EEF2F7]",
    chipText: "text-[#334155]",
    border: "border-[#DCE3EC]",
  },
  recommendation: {
    Icon: Sparkles,
    label: "Recomendación de AL DÍA",
    iconColor: "#3A6B56",
    chipBg: "bg-[#E8F0EC]",
    chipText: "text-[#2E5645]",
    border: "border-[#CBE0D4]",
  },
  verify: {
    Icon: AlertTriangle,
    label: "Conviene que lo verifiques",
    iconColor: "#D97706",
    chipBg: "bg-[#FEF3C7]",
    chipText: "text-[#92400E]",
    border: "border-[#FADFA0]",
  },
};

const InsightRow = ({ insight }) => {
  const meta = INSIGHT_META[insight.type] || INSIGHT_META.detected;
  const { Icon } = meta;
  return (
    <div className={`rounded-xl border ${meta.border} bg-white p-3.5`}>
      <span
        className={`inline-flex items-center gap-1.5 ${meta.chipBg} ${meta.chipText} text-xs font-bold uppercase tracking-wide px-2.5 py-1 rounded-full`}
      >
        <Icon size={14} style={{ color: meta.iconColor }} />
        {meta.label}
      </span>
      <p className="text-base text-[#1C2421] leading-relaxed mt-2">{insight.text}</p>
    </div>
  );
};

export const InsightList = ({ insights = [], limit }) => {
  const list = limit ? insights.slice(0, limit) : insights;
  if (!list.length) return null;
  return (
    <div className="space-y-2.5">
      {list.map((ins, i) => (
        <InsightRow key={i} insight={ins} />
      ))}
    </div>
  );
};
